import { render, staticRenderFns } from "./CollectionSelector.vue?vue&type=template&id=6b69e6d2&"
import script from "./CollectionSelector.vue?vue&type=script&lang=ts&"
export * from "./CollectionSelector.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionSelector.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports